import { useContext } from 'react'

import { TemplateSummaryContext } from 'features/tracked_meetings/template_summary_context'

import { ShareContext } from '../context'
import { EmailComposer } from './email_composer'

export const ShareEmailModal = ({
  onClose,
  onBack,
  emails,
  onShareLinkClick,
  videoPageUrl,
  isConfirmationPopupOpen,
  handleOpenConfirmationPopup,
  handleCloseConfirmationPopup,
  handleConfirmAction,
  closeModal,
  isAttendeeModal,
  attendeesFromSearchData,
}) => {
  const { share, shareUuid, eventUuid: meetingUuid } = useContext(ShareContext)
  const { summaries: templateSummaries } = useContext(TemplateSummaryContext)
  const { accessLevel, passcode: videoPasscode } = share

  return (
    <EmailComposer
      onClose={onClose}
      onBack={onBack}
      emails={emails}
      onShareLinkClick={onShareLinkClick}
      videoPageUrl={videoPageUrl}
      isConfirmationPopupOpen={isConfirmationPopupOpen}
      handleOpenConfirmationPopup={handleOpenConfirmationPopup}
      handleCloseConfirmationPopup={handleCloseConfirmationPopup}
      handleConfirmAction={handleConfirmAction}
      closeModal={closeModal}
      isAttendeeModal={isAttendeeModal}
      attendeesFromSearchData={attendeesFromSearchData}
      meetingUuid={meetingUuid}
      shareUuid={shareUuid}
      accessLevel={accessLevel}
      videoPasscode={videoPasscode}
      templateSummaries={templateSummaries}
      includePasscode
    />
  )
}
